module.exports = __webpack_public_path__ + "static/media/misson2.25209296.svg";